import sliceCreator from '../../index.jsx';
import {GET_ALL_PRE_SEASON_ACTIVITIES} from '../../../constants/index.jsx';
const _getAllPreSeasonActivitiesAction = sliceCreator('GET_ALL_PRE_SEASON_ACTIVITIES', GET_ALL_PRE_SEASON_ACTIVITIES, 'get');

const { asyncAction: getAllPreSeasonActivitiesAction, reducer, clearData: clearGetAllPreSeasonActivitiesAction } = _getAllPreSeasonActivitiesAction;

export default reducer;

export {
    getAllPreSeasonActivitiesAction,
    clearGetAllPreSeasonActivitiesAction
}